module.exports = __webpack_public_path__ + "static/media/img8.f077cde8.png";